import { useEffect, useRef, useState } from 'react';

// Collapsible help-modal section: chevron header, auto-scroll into view
// on USER expansion (extracted from Sidebar so atlas help-content packs
// can share it).
export default function HelpCollapsible({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const ref = useRef(null);
  // only auto-scroll on USER expansion — a defaultOpen section must not
  // yank the modal down to itself on mount
  const userToggled = useRef(false);

  // On expand, bring the section into view: fully visible when it fits,
  // top-aligned when it is taller than the modal's scroll area.
  useEffect(() => {
    if (!open || !ref.current || !userToggled.current) return;
    const t = setTimeout(() => {
      const el = ref.current;
      const scroller = el.closest('.help-modal__scroll');
      if (!el || !scroller) return;
      const elR = el.getBoundingClientRect();
      const scR = scroller.getBoundingClientRect();
      let delta = 0;
      if (elR.height > scR.height || elR.top < scR.top) delta = elR.top - scR.top;
      else if (elR.bottom > scR.bottom) delta = elR.bottom - scR.bottom + 10;
      if (delta !== 0) scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: 'smooth' });
    }, 30);
    return () => clearTimeout(t);
  }, [open]);

  return (
    <div className="help-modal__section" ref={ref}>
      <h3 className="help-modal__collapsible" onClick={() => { userToggled.current = true; setOpen(o => !o); }}>
        <span>{title}</span>
        <svg className={`detail__section-caret ${open ? 'detail__section-caret--up' : ''}`} width="10" height="7" viewBox="0 0 10 7"><polyline points="1,1 5,6 9,1" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </h3>
      {open && children}
    </div>
  );
}
